export const theme = {
  colors: {
    brandDark: '#003D2B',
    brandDarkTransparent: 'rgba(0, 61, 43, 0.05)',
    brandLight: '#ADE6B9',
    brandLime: '#DEF071',

    uiDark: '#00140F',
    uiDarkMedium: 'rgba(0, 20, 15, 0.7)',
    uiDarkDisabled: 'rgba(0, 20, 15, 0.3)',
    uiLight: '#FFFFFF',
    uiLightMedium: 'rgba(255, 255, 255, 0.6)',
    uiLightDisabled: 'rgba(255, 255, 255, 0.38)',
    uiGreyDarkPrimaryHover: '#545454',
    uiGreyDark: '#999999',
    uiGreyMedium: '#DDDDDD',
    uiGreyLight: '#F3F3F3',
    uiGrayUltralight: '#FAFAFA',
    uiGreen: '#009B67',
    uiGreenLight: '#D9F0E8',
    uiGreenMuted: '#A4CCC0',
    uiRed: '#B33636',
    uiRedLight: '#F4E1E1',
    uiRedMuted: '#F7D4D1',
    uiOrange: '#946200',
    uiOrangeLight: '#F4EDE1',
    uiOrangeMuted: '#EDCEB4',

    blueSky: '#24B0FF',

    playground1Dark: '#3D1400',
    playground1Light: '#E5BFAD',
    playground2Dark: '#3D3D00',
    playground2Light: '#E5E5AD',
    playground3Dark: '#003D3D',
    playground3Light: '#ADE5E5',
    playground4Dark: '#00003D',
    playground4Light: '#ADADE5',
    playground5Dark: '#3D003D',
    playground5Light: '#E5ADE5',
    playground6Dark: '#3D0014',
    playground6Light: '#E5ADBF',
    whatsapp: '#25d366',

    transparent: 'transparent',
    backdrop: 'rgba(74, 74, 74, 0.7)',
  },
  space: {
    none: 0,
    gutter: 24,
    xxsmall: 4,
    mini: 8,
    xsmall: 10,
    small: 16,
    medium: 20,
    large: 32,
    xlarge: 48,
    xlargeMedium: 64,
    xxlarge: 80,
    xxlargeMedium: 112,
    xxxlarge: 160,
  },
  radii: {
    none: 0,
    xsmall: 2,
    small: 4,
    normal: 8,
    medium: 10,
    large: 20,
    xlarge: 32,
    xxlarge: 40,
    xxxlarge: 50,
  },
  fontSizes: {
    '2xs': 10,
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 26,
    '4xl': 28,
    '5xl': 30,
    '6xl': 32,
    '7xl': 36,
    '8xl': 38,
    '9xl': 40,
    '10xl': 48,
    '11xl': 60,
    '12xl': 72,
    '13xl': 96,
    '14xl': 128,
  },
  lineHeights: {
    3: 12,
    4: 16,
    5: 18,
    6: 20,
    7: 22,
    8: 24,
    9: 26,
    10: 28,
    11: 30,
    12: 32,
    13: 36,
    14: 40,
    15: 44,
    16: 48,
    17: 52,
    18: 56,
  },
  iconSizes: {
    xsmall: 16,
    small: 24,
    medium: 40,
    large: 64,
    xlarge: 104,
  },
  sizes: {
    header: {
      mobile: 56,
      desktop: 72,
    },
  },
  fontFamily: {
    modernEraRegular: 'ModernEra-Regular',
    modernEraMedium: 'ModernEra-Medium',
    modernEraBold: 'ModernEra-Bold',
    adieuRegular: 'Adieu-Regular',
    adieuBold: 'Adieu-Bold',
  },
} as const

export const breakpoints = {
  XS: 0,
  s: 360,
  M: 768,
  L: 1024,
  XL: 1280,
  XXL: 1440,
}
